/**
 * 区域组件：区域 - 国家 搜索表单用
 * @Author: fjj
 * @History:
 * @Date      Version Remarks
 * ========= ======= ======================================================
 * 2022.05.21      1.0     First version
 *
 * @param onCountryClicked  当点击后回调(CountryId)
 * @param onCityClicked   选择城市 回调城市数组
 *
 * Copyright 2022, all rights reserved. Essa.cn
 */
import React from 'react';
import { Form, Row, Col, Select } from 'antd';
import { isEmpty,isEmptyObject } from "@utils/utils";
import RegionService from "./Region.action";

const { Option } = Select;
const FormItem = Form.Item;
class SearchFromRegion extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            listCountry :[],
            subList: [],
            loading: false,
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 请求地区列表
     * */
    getSaleMarketList(){
        const sUrl = "/service/fenxiao/buyer/queryCountry";
        this.loading(true)
        RegionService.postHttpAction(sUrl,{},'GET').then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));

    }
    handleRes(resData){
        const { success, valid, models=[], } = resData;
        this.loading(false)
        if (success && valid) {
            if(models&&models.length>0){
                const { initValue={} } = this.props;
                let subList = []
                if(!isEmpty(initValue.saleMarketId)){
                    const current = models.find(item=>item.saleMarketId==initValue.saleMarketId)||{};
                    if(!isEmptyObject(current)){
                        subList = current.countryList ||[]
                    }
                }else { //无默认值时 显示所有国家列表
                    models.forEach(item=>subList = [...subList,...item.countryList]);
                }
                this.setState({
                    listCountry : models||[],
                    subList:subList,
                    allSubList:subList,
                })
            }
        }
    }
    // 输出
    renderOptions(list=[]){
        const enumChildren = [];
        list.forEach((area,inx)=>{
            enumChildren.push(<Option key={area.id+'_'+inx} value={area.id} telCode={area.telCode} label={'+'+area.telCode}>+{area.telCode}<span>{area.name}</span></Option>);
        })
        return enumChildren;
    }
    /**
     * 选择国家
     * */
    handleCountryChange = (value,option) => {
        if(value){
            const { listCountry, } =this.state;
            const current = listCountry.find(item=>item.saleMarketId==value)||{}
            const countryCode = current.saleMarketId;
            const subList = current.countryList||[];
            if(this.props.onChange)this.props.onChange(countryCode);
            if(this.props.clearSubRegion)this.props.clearSubRegion('countryCode');
           this.setState({
               currentSaleMarket :value,
               subList:subList,
           })
        }else {
            const { allSubList } =this.state;
            if(this.props.onChange)this.props.onChange('');
            if(this.props.clearSubRegion)this.props.clearSubRegion('countryCode');
            this.setState({
                currentSaleMarket :'',
                subList: allSubList
            })
        }

    };

    componentWillMount() {
        this.getSaleMarketList();
    }
    componentDidMount() {
        if( this.props.onRef)  this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { disabled,required, formItemLayout,title,showSubTitle } = this.props;
        const { listCountry, subList, loading } = this.state;
        return ( <Row gutter={16}>
                    <Col span={12}>
                        <FormItem name={'saleMarketId'} label={title}
                                  rules={[{ required:required? true:false, message: __getServerLanguage("QingXuanZeQuYu")}]}>
                            <Select showSearch
                                   disabled={disabled}
                                   filterOption={(input, option) =>option.text.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                   allowClear
                                   loading={loading}
                                   placeholder={__getServerLanguage("QingXuanZeQuYu")} // 请选择区域
                                   onChange={(value,option)=>this.handleCountryChange(value,option)} >
                            {listCountry.map((saleMarket,inx) => (
                                <Option key={inx} value={saleMarket.saleMarketId+''} text={saleMarket.saleMarketName}>
                                    <span className={'margin-left-5'}>{saleMarket.saleMarketName}</span>
                                </Option>
                            ))}
                        </Select>
                        {/*)}*/}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem name={'countryCode'} label={showSubTitle||' '}
                                  rules={[{ required:required? true:false, message: __getServerLanguage("QingXuanZeGuoJia2")}]}>
                            <Select
                            showSearch
                            filterOption={(input, option) =>option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            allowClear
                            disabled={disabled}
                            placeholder={__getServerLanguage("QingXuanZeGuoJia2")}>
                            {subList.map((city,inx) => (
                                <Option key={inx} value={city.countryCode}>{city.countryName}</Option>
                            ))}
                        </Select>
                            {/*)}*/}
                        </FormItem>
                    </Col>
                    </Row>)
    }
}
export default SearchFromRegion;
